import React from 'react';
import type { IconProps } from '../types';

export const EscalateArrow = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      fill="none"
      fillRule="evenodd"
    >
      {/* Rounded square background */}
      <rect
        x="3"
        y="3"
        width="18"
        height="18"
        rx="4"
        fill="currentColor"
      />
      {/* Upward arrow */}
      <path
        d="M12 7.5a.75.75 0 0 1 .53.22l3 3a.75.75 0 1 1-1.06 1.06L12.75 9.56V16a.75.75 0 0 1-1.5 0V9.56l-1.72 1.72a.75.75 0 0 1-1.06-1.06l3-3A.75.75 0 0 1 12 7.5Z"
        fill="#ffffff"
      />
    </g>
  </svg>
);

export default EscalateArrow;
